import React from 'react'
import { Box, Button } from '@mui/material'
import images from 'assets/images'
import { URL_HOME } from 'helpers/config'
import serviceProviders from 'assets/icons/service-providers.svg'
import oneStop from 'assets/icons/one-stop.svg'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
// import SignUpSellerForm from 'components/pages/signup/SignUpSellerForm'
// import HighlightChip from 'components/HighlightChip'
import SignupTemplate from 'components/templates/SignupTemplate'
import useRedirectIfLoggedIn from 'hooks/useRedirectIfLoggedIn'
import AdvantagesContainer, { Advantage } from 'components/ui/AdvantagesContainer'
import FullScreenLoading from 'components/ui/FullScreenLoading'
import SignUpBuyerOptions from 'components/pages/signup/SignUpBuyerOptions'

const advantages: Advantage[] = [
  {
    image: oneStop,
    alt: 'One-stop shop for software & services!',
    title: '<strong>One-stop shop</strong> for software & services!',
    text: 'Buy software products at massive discounts. And find service providers who can help you operate your company. All in one place.',
  },
  {
    image: serviceProviders,
    alt: 'Choose from thousands of service providers',
    title: 'Choose from <strong>thousands of service providers</strong>',
    text: 'Browse, search and filter. Learn about their specific skill sets. Read reviews from past or current customers.',
  },
  {
    image: images.signUpSeller.PLUGIN,
    alt: 'Get matched with your ideal service provider',
    title: '<strong>Get matched</strong> with your ideal service provider',
    text: "NachoNacho's deep knowledge of both businesses like you as well as service providers facilitates perfect match-making.",
  },
]

const SignUpBuyerFinancing: React.FC = () => {
  const { loading } = useRedirectIfLoggedIn()

  if (loading) return <FullScreenLoading />

  return (
    <SignupTemplate
      left={
        <>
          <img src={images.LOGO_SYMBOL_BLUE_BACKGROUND} alt="logo" style={{ width: '110px', height: '110px' }} />

          <Box height="30px" />

          <Box>
            <h2 className="text-dark-blue fs-32 fw-700 m-0">Get capital for your business!</h2>
          </Box>

          <Box maxWidth="393px">
            <p className="m-6 fs-14">NachoNacho is the premier destination for companies to access capital to grow.</p>
          </Box>

          <Box height="54px" />

          <AdvantagesContainer advantages={advantages} />

          <Box height="41px" />

          <Button href={`${URL_HOME}/seller-meeting`} variant="text" className="fs-14 text-blue">
            Request a video call
            <KeyboardArrowRightIcon className="blue" fontSize="small" sx={{ ml: '3px' }} />
          </Button>
        </>
      }
      right={<SignUpBuyerOptions />}
    />
  )
}

export default SignUpBuyerFinancing
